import styled from 'styled-components';
import { fontBody, fontTitle } from 'Styles/fonts';

import PasswordInputOriginal from '../../../PasswordInput/PasswordInput';

export const UpdatePasswordForm = styled.div``;

export const Heading = styled.p`
  ${fontBody(16)};
  color: var(--foreground);
  margin: 0;
  padding: 0;
  margin-bottom: 16px;
  text-align: center;
`;

export const Emphasis = styled.span`
  ${fontTitle(16)};
  color: var(--foreground);
`;

export const PasswordInput = styled(PasswordInputOriginal)`
  margin-bottom: 16px;
`;
